import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import './style.scss'

interface ModalPopupProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    title: string
}

function InstructionPopup({
    open,
    setOpen,
    title,
}: ModalPopupProps) {

    return (
        <div className="modal-container">
            <Dialog open={open} onClose={() => setOpen(false)}>
                <div className='modal-header'>
                    <DialogTitle>{title}</DialogTitle>
                    <CloseIcon className='close-icon' onClick={() => setOpen(false)} />
                </div>
                <DialogContent>
                    <DialogContentText>
                        <div>
                            <b>Set Calculation rules</b>
                            <ul>
                                <li>
                                    You can create variables starting with <b>[@</b> and ends with <b>]</b>
                                </li>
                                <li>
                                    For example: <b>[@no_of_days]</b> is a variable
                                </li>
                                <li>
                                    In Calculation rules under settings, you can have calculations like <b>[@no_of_days] * 120</b>
                                </li>
                                <li>
                                    So when user types his days in UI and click on calculate, the output will be shown in <b>[@result]</b> variable
                                </li>
                            </ul>
                        </div>
                        <div>
                            <b>Create question with variable</b>
                            <ul>
                                <li>
                                    Enter your question in the given place with variable
                                </li>
                                <li>
                                    Example Question: <b>No of days you are going to stay is <b>[@no_of_days]</b> and <b>[@result]</b> is your total amount.
                                        click calculate to view the amount</b>
                                </li>
                                <li>
                                    In UI it will be as: <b>No of days you are going to stay is ________ and _______ is your total amount.
                                        click calculate to view the amount</b>
                                </li>
                                <li>
                                    Once the user clicks on calculate button, the output will be shown in <b>[@result]</b> variable.
                                </li>
                                <li>
                                    Always add <b>[@result]</b> variable to show the result.
                                </li>
                            </ul>
                        </div>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div >
    )
}

export default InstructionPopup